import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import UserContextProvider from "./Components/UserDetailsContextProvider";
import NavBar from "./Components/NavBar";
import Registration from "./Components/Registration";
import PaymentInfo from "./Payment/PaymentInfo";
import BookAnAppointment from "./Components/BookAnAppointment";

function App() {
  let [visible, setVisible] = useState(false);
  return (
    <div>
      <Router>
        <UserContextProvider>
          <header>
            <NavBar />
          </header>
          <Routes>
            {visible && (
              <>
                <Route path="/" element={<BookAnAppointment />} />
              </>
            )}

            <Route path="/" element={<Registration />} />
            <Route path="/payment" element={<PaymentInfo />} />
          </Routes>
        </UserContextProvider>
      </Router>
    </div>
  );
}

export default App;
